const memberBillingTypes = Object.freeze({
    DirectFromBankAccount: 1
});
export const memberBillingTypesNamesMap = Object.freeze({
    [memberBillingTypes.DirectFromBankAccount]: 'Direct from Bank Account'
});
export default memberBillingTypes;
